
import { loadMap } from './activityMaps';

$('[data-fancybox="activities"]').fancybox({
	baseClass: "day-details-modal",
	buttons: ["close"],
	fullScreen: true,
	// Set `touch: false` to disable panning/swiping
	touch: false,
	afterShow: function( instance, current ) {
		loadMap();
	}
});

// infobar: false,
// touch: {
//   vertical: false
// },
// buttons: ["close", "thumbs", "share"],
// animationEffect: "fade",
// transitionEffect: "fade",
// preventCaptionOverlap: false,
// idleTime: false,
// gutter: 0,
$('[data-fancybox="preview-target"]').fancybox({
	toolbar  : false,
	smallBtn : true,
	iframe : {
		preload : false
	}
});
